import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';


const QuickActions = ({ onCreateMeeting }) => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Create Meeting',
      icon: 'Plus',
      variant: 'default',
      onClick: onCreateMeeting
    },
    {
      label: 'Active Meetings',
      icon: 'Navigation',
      variant: 'outline',
      onClick: () => navigate('/active-meeting')
    },
    {
      label: 'Notification Settings',
      icon: 'Bell',
      variant: 'outline',
      onClick: () => navigate('/notification-settings')
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-md border border-border p-6 mb-8">
      <h2 className="font-heading text-xl font-semibold text-foreground mb-4">
        Quick Actions
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {actions?.map((action, index) => (
          <Button
            key={index}
            variant={action?.variant}
            iconName={action?.icon}
            iconPosition="left"
            onClick={action?.onClick}
            fullWidth
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;